"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledArrow = exports.StyledSpan = exports.StyledContent = exports.StyledTrigger = void 0;
const react_tooltip_1 = require("@radix-ui/react-tooltip");
const styled_components_1 = __importDefault(require("styled-components"));
const focusHover_1 = require("../../styles/focusHover");
const Tokens = __importStar(require("../../styles/tokens"));
const { white } = Tokens.COLOURS.greyscale;
const StyledTrigger = (0, styled_components_1.default)(react_tooltip_1.Trigger) `
    border: none;
    background: transparent;
    padding: 0;
    border-radius: ${({ radius }) => radius};

    &:focus&:focus,
    &:focus-visible {
        ${focusHover_1.focusOnlyStyles}
    }
`;
exports.StyledTrigger = StyledTrigger;
const StyledContent = (0, styled_components_1.default)(react_tooltip_1.Content) `
    border-radius: ${Tokens.BORDERS.radius};
    padding: ${Tokens.SIZES[1]};
    box-shadow: 0 ${Tokens.SIZES[0.5]} ${Tokens.SIZES[2]} rgb(68 72 126 / 32%);
    background-color: ${white};
`;
exports.StyledContent = StyledContent;
const StyledArrow = (0, styled_components_1.default)(react_tooltip_1.Arrow) `
    fill: ${white};
`;
exports.StyledArrow = StyledArrow;
const StyledSpan = styled_components_1.default.span `
    display: inline-block;
    border-radius: ${Tokens.BORDERS.radius};

    &:focus&:focus,
    &:focus-visible {
        ${focusHover_1.focusOnlyStyles}
    }
`;
exports.StyledSpan = StyledSpan;
//# sourceMappingURL=Tooltip.styles.js.map